import {
  SET_CARD_DEFAULT,
  SET_CARD_TYPING,
  SET_CARD_TYPING_FOCUSED_FIELD,
  SET_CARD_SHOW,
  SET_CARD_LIST,
  CLEAN_CARD_DEFAULT,
  CLEAN_CARD_TYPING,
  CLEAN_CARD_SHOW,
  SET_IS_TYPING_CARD,
  SET_IS_SHOWING_CARD,
  SHOW_CARD,
  ADD_CARD_TO_CARD_LIST,
  REMOVE_CARD_FROM_CARD_LIST,
  SET_PREFERRED_CARD
} from '../actions'

export const setCardDefault = card => ({
  type: SET_CARD_DEFAULT,
  payload: card
})

export const setCardTyping = card => ({
  type: SET_CARD_TYPING,
  payload: card
})
export const setCardTypingFocusedField = field => ({
  type: SET_CARD_TYPING_FOCUSED_FIELD,
  payload: field
})

export const setCardShow = card => ({
  type: SET_CARD_SHOW,
  payload: card
})

export const setCardList = cardList => ({
  type: SET_CARD_LIST,
  payload: cardList
})

export const addCardToCardList = card => ({
  type: ADD_CARD_TO_CARD_LIST,
  payload: card
})

export const removeCardFromCardList = ({ cardID, newDefaultCardID }) => ({
  type: REMOVE_CARD_FROM_CARD_LIST,
  payload: { cardID, newDefaultCardID }
})

export const setPreferredCard = cardID => ({
  type: SET_PREFERRED_CARD,
  payload: cardID
})

export const cleanCardDefault = () => ({ type: CLEAN_CARD_DEFAULT })

export const cleanCardTyping = () => ({ type: CLEAN_CARD_TYPING })

export const cleanCardShow = () => ({ type: CLEAN_CARD_SHOW })


export const setIsTypingCard = isTypingCard => ({
  type: SET_IS_TYPING_CARD,
  payload: isTypingCard
})

export const setIsShowingCard = isShowingCard => ({
  type: SET_IS_SHOWING_CARD,
  payload: isShowingCard
})

export const showCard = cardID => ({
  type: SHOW_CARD,
  payload: cardID
})
